
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayDigitalNonReturn as ObiTwowayDigitalNonReturnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-digital-non-return.js';
 
 
 

 
 export const ObiTwowayDigitalNonReturn = createComponent({
   react: React,
   tagName: 'obi-twoway-digital-non-return',
   elementClass: ObiTwowayDigitalNonReturnElement,
   events: {
     
   }
  });
 
 